export default "__VITE_ASSET__df01abc6__"